import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { ID } from "src/libs/interfaces/layouts"
import { showToast } from "src/libs/useful"
import CalloutNoExists from "src/libs/useful/CalloutNoExists"
import { shuffle } from "src/libs/utilities"
import { IPETest, PE_TEST_QUESTION_TYPE, PETestQuestion } from "../../data/interfaces"
import { ITestsStore, useTestsStore } from "../../data/store"
import MultiChoice from "./questions/MultiChoice"
import Range from "./questions/Range"
import { ITestProps } from "./SingleTest"

const Question = (props: ITestProps) : JSX.Element => {
    const params = useParams() 
    const item: IPETest = useTestsStore((state:ITestsStore) => state.currentTest)
    const [question, setQuestion]= useState<PETestQuestion>({} as PETestQuestion)
    const [choosedId, setChoosedId]= useState<ID>( -1 )
    const [isRight, setIsRight]= useState<ID>( -1 )
    const [isLocked, setIsLocked]= useState<boolean>( false )

    useEffect(() => { 
        const question = item.questions.filter(q => q.id.toString() === params.question_id)[0] 
        //console.log( item.questions, question)
        if(!question){
            showToast({
                message: "No question"
            })
            return
        }
        setQuestion( {...question, answers: shuffle(question.answers)} )
        setChoosedId(-1)
        setIsRight(-1)
        setIsLocked(false)
    }, [ params.question_id ])

    return question.id 
        ?
        <QuestionByType 
            item={item} 
            question={question} 
            choosedId={choosedId} 
            isRight={isRight} 
            isLocked={isLocked} 
            setChoosedId={setChoosedId} 
            setIsRight={setIsRight} 
            setIsLocked={setIsLocked} 
        />
        :
        <CalloutNoExists /> 
} 
export default Question

export interface IQuestProps {
    item: IPETest
    question: PETestQuestion
    choosedId: ID,
    isRight: ID
    isLocked: boolean,
    setIsRight: (val: ID) => void
    setChoosedId: (val: ID) => void
    setIsLocked: (val: boolean) => void
}
export const QuestionByType = (props: IQuestProps) : JSX.Element => {
    switch(props.question.type) {
        case PE_TEST_QUESTION_TYPE.RANGE:
            return <Range {...props} /> 
        case PE_TEST_QUESTION_TYPE.MULTI_CHOOSE:
        default:
            return <MultiChoice {...props} />
    }
}